export const updatedDeviceList = async () => {
  let videoLabels = [];
  let audioLabels = [];
  let micCounter = 0;
  let cameraCounter = 0;
  return new Promise((resolve, reject) => {
    navigator.mediaDevices.enumerateDevices().then(function (devices) {
      devices.forEach((device) => {
        if (device.kind === "audioinput") {
          micCounter++;
          let micLabel = device.label || `Mic-${micCounter}`;
          audioLabels.push({ id: device.deviceId, label: micLabel });
        }
        if (device.kind === "videoinput") {
          cameraCounter++;
          let cameraLabel = device.label || `Camera ${cameraCounter}`;
          videoLabels.push({ id: device.deviceId, label: cameraLabel });
        }
      });
      resolve({ audioLabels, videoLabels });
    });
  });
};
